import React from 'react';
import {
  Sparkles, Linkedin, Play, Shield, Cloud, FileText, Music, PenTool,
  Palette, Youtube, Tv, ShoppingBag, Bot, Brain, Zap, Wand2, Bell,
  Mic, Video, Image as ImageIcon, Layers, Terminal, Code2, Rocket,
  Gamepad2, MessageCircle, Camera, Newspaper, Briefcase, Globe,
  BookOpen, Headphones, Film, MonitorPlay, Puzzle, Server,
} from 'lucide-react';
import {
  ClaudeIcon, GeminiIcon, PerplexityIcon, MidjourneyIcon, LovableIcon,
  ReplitIcon, CursorIcon, KreaIcon, GammaIcon, RunwayIcon, SunoIcon,
  V0Icon, GithubIcon, CopilotIcon, FigmaIcon, VercelIcon, DiscordIcon,
  WhatsappIcon, InstagramIcon, XIcon, TelegramIcon, OpenRouterIcon,
  AppleIcon, WindowsIcon,
} from './BrandIcons';

/**
 * Central registry of product icons.
 * Add new entries here to expose them in admin Product form.
 */
export const ICON_REGISTRY = [
  // --- AI / LLM ---
  { key: 'openai',      label: 'OpenAI / ChatGPT',   Icon: Sparkles,        color: '#10a37f', group: 'AI' },
  { key: 'claude',      label: 'Claude (Anthropic)', Icon: ClaudeIcon,      color: '#d97757', group: 'AI' },
  { key: 'gemini',      label: 'Google Gemini',      Icon: GeminiIcon,      color: '#4285f4', group: 'AI' },
  { key: 'perplexity',  label: 'Perplexity',         Icon: PerplexityIcon,  color: '#20b2aa', group: 'AI' },
  { key: 'copilot',     label: 'GitHub Copilot',     Icon: CopilotIcon,     color: '#7c3aed', group: 'AI' },
  { key: 'grok',        label: 'Grok (xAI)',         Icon: Brain,           color: '#e6e6e6', group: 'AI' },
  { key: 'deepseek',    label: 'DeepSeek',           Icon: Bot,             color: '#3b82f6', group: 'AI' },
  { key: 'openrouter',  label: 'OpenRouter',         Icon: OpenRouterIcon,  color: '#8b5cf6', group: 'AI' },

  // --- AI Image / Video / Audio ---
  { key: 'midjourney',  label: 'Midjourney',         Icon: MidjourneyIcon,  color: '#2b2b3f', group: 'AI Media' },
  { key: 'runway',      label: 'Runway ML',          Icon: RunwayIcon,      color: '#10b981', group: 'AI Media' },
  { key: 'suno',        label: 'Suno AI',            Icon: SunoIcon,        color: '#a855f7', group: 'AI Media' },
  { key: 'krea',        label: 'Krea AI',            Icon: KreaIcon,        color: '#ec4899', group: 'AI Media' },
  { key: 'gamma',       label: 'Gamma AI',           Icon: GammaIcon,       color: '#a78bfa', group: 'AI Media' },
  { key: 'leonardo',    label: 'Leonardo AI',        Icon: Wand2,           color: '#f59e0b', group: 'AI Media' },
  { key: 'elevenlabs',  label: 'ElevenLabs',         Icon: Mic,             color: '#e6e6e6', group: 'AI Media' },
  { key: 'heygen',      label: 'HeyGen',             Icon: Video,           color: '#0ea5e9', group: 'AI Media' },
  { key: 'ideogram',    label: 'Ideogram',           Icon: ImageIcon,       color: '#f43f5e', group: 'AI Media' },

  // --- Dev / Code / IDE ---
  { key: 'cursor',      label: 'Cursor',             Icon: CursorIcon,      color: '#a78bfa', group: 'Developer' },
  { key: 'lovable',     label: 'Lovable',            Icon: LovableIcon,     color: '#ff2e88', group: 'Developer' },
  { key: 'replit',      label: 'Replit',             Icon: ReplitIcon,      color: '#f26207', group: 'Developer' },
  { key: 'v0',          label: 'v0 by Vercel',       Icon: V0Icon,          color: '#e6e6e6', group: 'Developer' },
  { key: 'github',      label: 'GitHub',             Icon: GithubIcon,      color: '#e6e6e6', group: 'Developer' },
  { key: 'vercel',      label: 'Vercel',             Icon: VercelIcon,      color: '#e6e6e6', group: 'Developer' },
  { key: 'figma',       label: 'Figma',              Icon: FigmaIcon,       color: '#f24e1e', group: 'Developer' },
  { key: 'jetbrains',   label: 'JetBrains',          Icon: Code2,           color: '#ff5e79', group: 'Developer' },
  { key: 'stackblitz',  label: 'StackBlitz / Bolt',  Icon: Zap,             color: '#facc15', group: 'Developer' },
  { key: 'windsurf',    label: 'Windsurf',           Icon: Terminal,        color: '#06b6d4', group: 'Developer' },

  // --- Cloud (Claude prominent alternative) ---
  { key: 'claude_pro', label: 'Claude Pro',           Icon: ClaudeIcon,      color: '#d97757', group: 'Claude' },
  { key: 'claude_max', label: 'Claude Max',           Icon: ClaudeIcon,      color: '#c2410c', group: 'Claude' },
  { key: 'claude_team',label: 'Claude Team',          Icon: ClaudeIcon,      color: '#ea580c', group: 'Claude' },

  // --- Streaming ---
  { key: 'netflix',     label: 'Netflix',            Icon: Play,            color: '#e50914', group: 'Streaming' },
  { key: 'youtube',     label: 'YouTube Premium',    Icon: Youtube,         color: '#ff0000', group: 'Streaming' },
  { key: 'spotify',     label: 'Spotify',            Icon: Music,           color: '#1db954', group: 'Streaming' },
  { key: 'disney',      label: 'Disney+ / Hotstar',  Icon: Tv,              color: '#0063e5', group: 'Streaming' },
  { key: 'prime',       label: 'Amazon Prime',       Icon: ShoppingBag,     color: '#00a8e1', group: 'Streaming' },
  { key: 'hbo',         label: 'HBO / Max',          Icon: Film,            color: '#a855f7', group: 'Streaming' },
  { key: 'apple_tv',    label: 'Apple TV+',          Icon: MonitorPlay,     color: '#e6e6e6', group: 'Streaming' },
  { key: 'crunchyroll', label: 'Crunchyroll',        Icon: Tv,              color: '#f47521', group: 'Streaming' },

  // --- Productivity ---
  { key: 'notion',      label: 'Notion',             Icon: FileText,        color: '#e5e5e5', group: 'Productivity' },
  { key: 'canva',       label: 'Canva Pro',          Icon: Palette,         color: '#00c4cc', group: 'Productivity' },
  { key: 'grammarly',   label: 'Grammarly',          Icon: PenTool,         color: '#15c39a', group: 'Productivity' },
  { key: 'office365',   label: 'Microsoft 365',      Icon: Briefcase,       color: '#d83b01', group: 'Productivity' },
  { key: 'linkedin',    label: 'LinkedIn Premium',   Icon: Linkedin,        color: '#0a66c2', group: 'Productivity' },
  { key: 'quillbot',    label: 'Quillbot',           Icon: BookOpen,        color: '#22c55e', group: 'Productivity' },

  // --- VPN / Security ---
  { key: 'nordvpn',     label: 'NordVPN',            Icon: Shield,          color: '#4687ff', group: 'VPN' },
  { key: 'expressvpn',  label: 'ExpressVPN',         Icon: Shield,          color: '#da3940', group: 'VPN' },
  { key: 'surfshark',   label: 'Surfshark',          Icon: Shield,          color: '#00b2a9', group: 'VPN' },
  { key: 'protonvpn',   label: 'ProtonVPN',          Icon: Shield,          color: '#6d4aff', group: 'VPN' },
  { key: 'protonmail',  label: 'ProtonMail',         Icon: Newspaper,       color: '#6d4aff', group: 'VPN' },
  { key: '1password',   label: '1Password',          Icon: Shield,          color: '#0572ec', group: 'VPN' },

  // --- Games / Consoles ---
  { key: 'steam',       label: 'Steam',              Icon: Gamepad2,        color: '#1b2838', group: 'Games' },
  { key: 'xbox',        label: 'Xbox Live',          Icon: Gamepad2,        color: '#107c10', group: 'Games' },
  { key: 'playstation', label: 'PlayStation',        Icon: Gamepad2,        color: '#003791', group: 'Games' },
  { key: 'discord',     label: 'Discord Nitro',      Icon: DiscordIcon,     color: '#5865f2', group: 'Games' },

  // --- Social / Messaging ---
  { key: 'telegram',    label: 'Telegram',           Icon: TelegramIcon,    color: '#26a5e4', group: 'Social' },
  { key: 'whatsapp',    label: 'WhatsApp',           Icon: WhatsappIcon,    color: '#25d366', group: 'Social' },
  { key: 'instagram',   label: 'Instagram',          Icon: InstagramIcon,   color: '#e1306c', group: 'Social' },
  { key: 'x',           label: 'X / Twitter',        Icon: XIcon,           color: '#e6e6e6', group: 'Social' },

  // --- Learning ---
  { key: 'coursera',    label: 'Coursera',           Icon: BookOpen,        color: '#0056d2', group: 'Learning' },
  { key: 'udemy',       label: 'Udemy',              Icon: BookOpen,        color: '#a435f0', group: 'Learning' },
  { key: 'audible',     label: 'Audible',            Icon: Headphones,      color: '#f8991c', group: 'Learning' },
];

const ICON_MAP = ICON_REGISTRY.reduce((acc, item) => {
  acc[item.key] = { Icon: item.Icon, color: item.color };
  return acc;
}, {});

const DEFAULT_CFG = { Icon: Sparkles, color: '#22c55e' };

const ProductIcon = ({ type, size = 20 }) => {
  const cfg = ICON_MAP[type] || DEFAULT_CFG;
  const { Icon, color } = cfg;
  return (
    <span
      className="inline-flex items-center justify-center rounded-md shrink-0"
      style={{
        width: size + 12,
        height: size + 12,
        background: `${color}1a`,
        border: `1px solid ${color}55`,
      }}
    >
      <Icon size={size} style={{ color }} strokeWidth={1.8} />
    </span>
  );
};

export const BigProductWatermark = ({ type }) => {
  const cfg = ICON_MAP[type] || DEFAULT_CFG;
  const { Icon, color } = cfg;
  return (
    <Icon
      size={160}
      strokeWidth={1.2}
      style={{ color, opacity: 0.12, position: 'absolute', right: -18, bottom: -20, pointerEvents: 'none' }}
    />
  );
};

export default ProductIcon;
